import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { PFieldAbstractComponent } from '../p-field-abstract';
import { getWeekDayShortName, WeekdayEnum } from '@frontend-site/shared/utils';

@Component({
    selector: 'p-field-weekday',
    template: `
        <p-field
            [isMandatory]="isMandatory"
            [label]="label"
            [labelTooltip]="labelTooltip"
            [isReadOnly]="isReadOnly"
            [isDisable]="isDisabled"
            [shouldTransformLabelTextCase]="shouldTransformLabelTextCase"
        >
            <div slot="editMode">
                <div class="weekday-checkboxes">
                    <p-checkbox
                        *ngFor="let weekDay of weekDaysArray"
                        [attr.automation-id]="'p-field-checkbox_' + label"
                        [label]="weekDay.name"
                        [checked]="isSelected(weekDay.key)"
                        (checkedChange)="checkedChange(weekDay.key, $event)"
                    ></p-checkbox>
                </div>
            </div>
            <div slot="readMode">
                <div class="weekday-checkboxes">
                    <p-checkbox
                        *ngFor="let weekDay of weekDaysArray"
                        [attr.automation-id]="'p-field-checkbox_' + label"
                        readonly
                        [label]="weekDay.name"
                        [checked]="isSelected(weekDay.key)"
                        [disabled]="true"
                        (checkedChange)="checkedChange(weekDay.key, $event)"
                    ></p-checkbox>
                </div>
            </div>
        </p-field>
    `,
    styleUrls: ['./p-field-weekday.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: PFieldWeekdayComponent
        }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'pFieldWeekday'
})
export class PFieldWeekdayComponent extends PFieldAbstractComponent<number[]> {
    @Input() label?: string;
    @Input() isMandatory = false;

    isSelected(weekDayIndex: number): boolean {
        return !!this.value?.includes(weekDayIndex);
    }

    checkedChange(selectedWeekDayIndex: number, isSelected: boolean): void {
        this.markAsTouched();
        if (!this.isReadOnly) {
            if (isSelected) {
                this.value?.push(selectedWeekDayIndex);
            } else {
                this.value = this.value?.filter((weekday: number) => weekday !== selectedWeekDayIndex);
            }
            this._onChange(this.value);
        }
    }

    constructor(cd: ChangeDetectorRef) {
        super(cd);
    }

    readonly weekDaysArray: readonly { key: number; name: string }[] = [
        {
            key: WeekdayEnum.Sunday,
            name: getWeekDayShortName(WeekdayEnum.Sunday)
        },
        {
            key: WeekdayEnum.Monday,
            name: getWeekDayShortName(WeekdayEnum.Monday)
        },
        {
            key: WeekdayEnum.Tuesday,
            name: getWeekDayShortName(WeekdayEnum.Tuesday)
        },
        {
            key: WeekdayEnum.Wednesday,
            name: getWeekDayShortName(WeekdayEnum.Wednesday)
        },
        {
            key: WeekdayEnum.Thursday,
            name: getWeekDayShortName(WeekdayEnum.Thursday)
        },
        {
            key: WeekdayEnum.Friday,
            name: getWeekDayShortName(WeekdayEnum.Friday)
        },
        {
            key: WeekdayEnum.Saturday,
            name: getWeekDayShortName(WeekdayEnum.Saturday)
        }
    ] as const;
}
